// Funnel-event helper. Dual-emit to Vercel Analytics (always, when
// deployed on Vercel) and Plausible (only when VITE_PLAUSIBLE_DOMAIN
// is set so window.plausible exists). Both providers attach their own
// timestamp at ingestion.

import { track as vercelTrack } from '@vercel/analytics'

const SS_VISIT_FIRED = 'verdant_visit_fired'
// Per-pubkey first-vote dedupe. Key is LS_FIRST_VOTE_PREFIX + pubkey.
// The old un-namespaced 'verdant_first_vote_fired' key (cleared on
// boot by migrateLocalStorageKeys) carried whichever pubkey last
// voted and could mis-attribute or skip events when accounts
// switched on shared devices (O06).
const LS_FIRST_VOTE_PREFIX = 'verdant_first_vote_fired_'

export function track(event, props) {
  try { vercelTrack(event, props) } catch { /* noop */ }
  try {
    if (typeof window !== 'undefined' && typeof window.plausible === 'function') {
      window.plausible(event, props ? { props } : undefined)
    }
  } catch { /* noop */ }
}

// Once per browser session.
export function trackVisit() {
  try {
    if (sessionStorage.getItem(SS_VISIT_FIRED)) return
    sessionStorage.setItem(SS_VISIT_FIRED, '1')
  } catch { /* noop */ }
  track('visit')
}

// Once forever per pubkey, persisted in a per-pubkey localStorage
// key so a second account on the same device gets its own first_vote
// credit. With no pubkey we fire the event but skip the persistence
// step (nothing to dedupe against).
export function trackFirstVote({ pubkey, ...props } = {}) {
  if (!pubkey) {
    track('first_vote', props)
    return
  }
  try {
    const key = LS_FIRST_VOTE_PREFIX + pubkey
    if (localStorage.getItem(key)) return
    localStorage.setItem(key, '1')
  } catch { /* noop */ }
  track('first_vote', props)
}
